
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns94e2135f7e529ddcabd5cbbc445ef17een from './en.yaml'
            i18n.addResourceBundle('en', '94e2135f7e529ddcabd5cbbc445ef17e', flattenObject(ns94e2135f7e529ddcabd5cbbc445ef17een), true, true);
        
        export default '94e2135f7e529ddcabd5cbbc445ef17e';
    